const MyAssignmentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.75 3C4.67893 3 3 4.67893 3 6.75V17.25C3 19.3211 4.67893 21 6.75 21H17.25C19.3211 21 21 19.3211 21 17.25V6.75C21 4.67893 19.3211 3 17.25 3H6.75ZM4.5 6.75C4.5 5.50736 5.50736 4.5 6.75 4.5H17.25C18.4926 4.5 19.5 5.50736 19.5 6.75V17.25C19.5 18.4926 18.4926 19.5 17.25 19.5H6.75C5.50736 19.5 4.5 18.4926 4.5 17.25V6.75ZM8 7.5H16V9H8V7.5ZM8 10.5H16V12H8V10.5ZM8 13.5H12V15H8V13.5Z"
      fill="#747474"
    />
  </svg>
);

export default MyAssignmentIcon;
